export class DodajPomieszczenieModel {
    idLokalizacji: string;
    nazwa: string;
    pietro: string;
    mpk: string;
    opisDodatkowy: string;
    osoba: string;
    inne: string;
}